import { schema } from 'normalizr';

const mediaSchema = new schema.Entity('media', {});

export default mediaSchema;
